<form [formGroup]="salaryForm" (ngSubmit)="onSubmit()" class="follow-up-form">
  <div class="salary-meta">
    <div class="salary-meta-row">
      <div class="salary-meta-label">
        <i class="bi bi-briefcase"></i>
        {{ t.JOB_TITLE }}
      </div>
      <div class="salary-meta-value">{{ jobTitle }}</div>
    </div>
    <div class="salary-meta-row">
      <div class="salary-meta-label">
        <i class="bi bi-building"></i>
        {{ t.COMPANY }}
      </div>
      <div class="salary-meta-value">{{ companyName }}</div>
    </div>
    <div class="salary-meta-row">
      <div class="salary-meta-label">
        <i class="bi bi-hash"></i>
        {{ t.APPLICATION_ID }}
      </div>
      <div class="salary-meta-value">{{ applicationId }}</div>
    </div>
  </div>
  <div class="salary-grid">
    <div class="form-group">
      <label for="salary_min_value">{{ t.LABEL_MIN_SALARY }}</label>
      <input
        id="salary_min_value"
        type="number"
        formControlName="salary_min_value"
        [attr.placeholder]="t.PLACEHOLDER_MIN_SALARY"
      />
    </div>
    <div class="form-group">
      <label for="salary_max_value">{{ t.LABEL_MAX_SALARY }}</label>
      <input
        id="salary_max_value"
        type="number"
        formControlName="salary_max_value"
        [attr.placeholder]="t.PLACEHOLDER_MAX_SALARY"
      />
    </div>
    <div class="form-group">
      <label for="salary_target_value">{{ t.LABEL_TARGET_VALUE }}</label>
      <input
        id="salary_target_value"
        type="number"
        formControlName="salary_target_value"
        [attr.placeholder]="t.PLACEHOLDER_TARGET_VALUE"
      />
    </div>
  </div>
  <div class="form-group">
    <label for="salary_company_message">{{ t.LABEL_COMPANY_MESSAGE }}</label>
    <textarea
      id="salary_company_message"
      formControlName="salary_company_message"
      rows="3"
      [attr.placeholder]="t.PLACEHOLDER_COMPANY_MESSAGE"
    ></textarea>
  </div>
  <div class="form-actions">
    <button type="submit" [disabled]="salaryForm.invalid || isSubmitting">
      {{ isSubmitting ? t.BUTTON_SAVING : t.BUTTON_SAVE }}
    </button>
    <button type="button" (click)="onCancel()">{{ t.BUTTON_CANCEL }}</button>
  </div>
</form>
